export default {
  textual (data, title) {
    return {
      report: data,
      title: title
    }
  },
  chart (data, title) {
    return {
      report: {
        labels: createChartLabels(data),
        datasets: createChartDatasets(data)
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: title
        },
        scales: {
          yAxes: [{
            ticks: {
              callback: (value, index, values) => {
                return Number(value).toLocaleString('pt-BR')
              }
            }
          }],
          xAxes: [{
            ticks: {
              autoSkip: false,
              maxRotation: 60,
              minRotation: 0,
              callback: function (xLabel) {
                return truncate(xLabel, 25)
              }
            }
          }]
        },
        tooltips: {
          enabled: true,
          callbacks: {
            title: (tooltipItems, data) => {
              const idx = tooltipItems[0].index
              return data.labels[idx]
            },
            label: (tooltipItems, data) => {
              return Number(tooltipItems.yLabel).toLocaleString('pt-BR')
            }
          }
        }
      }
    }
  },
  horizontalBarChart (data, title) {
    const chart = this.chart(data, title)

    chart.options.scales.yAxes = [{
      ticks: {
        callback: function (yLabel) {
          return truncate(yLabel, 25)
        }
      }
    }]

    chart.options.scales.xAxes = [{
      ticks: {
        callback: (value, index, values) => {
          return Number(value).toLocaleString('pt-BR')
        }
      }
    }]

    chart.options.tooltips.callbacks.label = (tooltipItems, data) => {
      return Number(tooltipItems.xLabel).toLocaleString('pt-BR')
    }

    return chart
  },
  doughnutChart (data, title) {
    const reportDatasets = createChartDatasets(data)
    reportDatasets[0].borderColor = colors
    reportDatasets[0].backgroundColor = colors

    const chart = this.chart(data, title)
    chart.report.datasets = reportDatasets
    chart.options.scales = false
    chart.options.tooltips.callbacks.label = (tooltipItems, data) => {
      const idx = tooltipItems.index
      const value = data.datasets[0].data[idx]
      return Number(value).toLocaleString('pt-BR')
    }

    return chart
  },
  stackedBarChart (data, title) {
    const chart = this.chart(data, title)
    chart.options.scales.xAxes = [{
      stacked: true
    }]
    chart.options.scales.yAxes = [{
      stacked: true
    }]
    chart.options.tooltips.callbacks.title = (tooltipItems, data) => {
      const idx = tooltipItems[0].datasetIndex
      return data.datasets[idx].label + ' - ' + tooltipItems[0].label
    }
    return chart
  }
}

const createChartLabels = function (chartData) {
  const nonEmptyDataset = chartData.find(dataset => Object.keys(dataset.result).length)
  return Object.keys(nonEmptyDataset.result).map(stripTags)
}

const stripTags = function (str) {
  return str.replace(/<(?:.|\n)*?>/gm, '')
}

const truncate = function (str, maxLength = 30) {
  if (str.length <= maxLength) {
    return str
  }
  return str.substr(0, maxLength).trim() + '...'
}

const colors = [
  '#3c8dbc', '#00c0ef', '#f56954',
  '#3c4dbc', '#3cbcab', '#bc3c4d',
  '#bd3ca1', '#f3d512', '#1f1f1f',
  '#214034', '#351224', '#b99f52',
  '#424240', '#66787b', '#643c24'
]

const createChartDatasets = function (chartData) {
  let datasets = []
  Object.keys(chartData).forEach(function (index) {
    let dataset = {
      label: truncate(String(chartData[index].label), 45),
      borderColor: colors[index],
      backgroundColor: colors[index],
      fill: false,
      data: Object.values(chartData[index].result)
    }
    datasets.push(dataset)
  })

  return datasets
}



// WEBPACK FOOTER //
// ./src/services/report_formatter.js